// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"21d52d36","162":"091d4540","167":"b840ba84","189":"ce2444f2","238":"078e352d","359":"485073b6","791":"9d5ca3f9","810":"ee673953","811":"2d7e79c0","846":"ae7ae02f","883":"d8d1b32e","969":"ccff62c2"}[chunkId] + ".chunk.js";
};